import React, { useEffect, useState } from 'react';
import { Container, Grid, CircularProgress, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import TableComponent from '../Component/TableComponent';
import NetworkTabs from '../Component/NetworkTabs';
import CummulativeData from '../Component/CummulativeData';

import { getNetworkInfoList } from '../action';
import { getBuyerRolesAction } from '../../Onboarding/auth/action';

const VcpPerformanceDirectory = () => {
  const navigate = useNavigate();

  const [networkListData, setNetworkListData] = useState({});
  const [loading, setLoading] = useState(false);
  const [onboardBuyerRoleData, setOnboardBuyerRoleData] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState({
    firm_role_id: null,
    firm_role_type: '',
  });

  const { company_details } = useSelector((state) => ({
    company_details: state.reportReducer.company_details,
  }));

  const getOnboardBuyerRoles = async () => {
    const { data, error, message } = await getBuyerRolesAction(
      Number(company_details?.id),
      false,
      true,
    );

    if (!error) {
      const influencerRoles = data.roles.filter(
        ({ region_role_id }) => region_role_id === null,
      );

      const updatedRoles = data.roles
        .filter(({ region_role_id }) => region_role_id !== null)
        .concat(
          influencerRoles.length > 0
            ? {
                display_name: 'INFLUENCER',
                firm_role_id: null,
                firm_role_type: 'INFLUENCER',
              }
            : [],
        );

      setOnboardBuyerRoleData(updatedRoles);
    } else {
      toast.error(message);
    }
  };

  const getNetworkInfoData = async () => {
    if (!company_details?.id || !selectedFirm.firm_role_type) return;

    const payload = {
      manufacturer_id: company_details.id,
      firm_role_type: selectedFirm.firm_role_type,
      ...(selectedFirm.firm_role_id !== null && {
        firm_role_id: selectedFirm.firm_role_id,
      }),
    };

    setLoading(true);

    const { data, error, message } = await getNetworkInfoList(payload);
    if (!error) {
      setNetworkListData(data);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (onboardBuyerRoleData.length > 0 && !selectedFirm.firm_role_type) {
      setSelectedFirm({
        firm_role_id: onboardBuyerRoleData[0].firm_role_id,
        firm_role_type: onboardBuyerRoleData[0].display_name,
      });
    }
  }, [onboardBuyerRoleData]);

  useEffect(() => {
    if (company_details?.id) {
      getOnboardBuyerRoles();
    }
  }, [company_details?.id]);
  useEffect(() => {
    if (selectedFirm.firm_role_type && company_details?.id) {
      getNetworkInfoData();
    }
  }, [selectedFirm, company_details?.id]);

  return (
    <Container
      maxWidth={false}
      sx={{
        pl: '2rem',
        pt: '2rem',
        height: '100vh',
        overflowY: 'auto',
        pb: 10,
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems='stretch'
      >
        <Grid
          item
          xs={8}
        >
          <NetworkTabs
            networkList={onboardBuyerRoleData}
            setSelectedFirm={setSelectedFirm}
          />
        </Grid>
        <Grid
          item
          xs={4}
        >
          <CummulativeData networkListData={networkListData} />
        </Grid>

        <Grid
          item
          xs={12}
        >
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <TableComponent
              data={networkListData?.vcp_wise_sales || []}
              columns={[
                { key: 'company_name', label: 'Name' },
                { key: 'state', label: 'State' },
                { key: 'district', label: 'District' },
                {
                  key: 'secondary_uom',
                  label: 'UOM',
                  render: (item) => item?.prefix_uom || item?.suffix_uom,
                },
                { key: 'current_month_sales', label: "This Month's Sale" },
                { key: 'total_sales_ytd', label: 'YTD Sales' },
                { key: 'active_influencers', label: 'Active Influencer' },
                {
                  key: 'status',
                  label: 'Active Status',
                  render: (item) => (
                    <Box
                      sx={{
                        display: 'inline-block',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        backgroundColor:
                          item?.status === 'INACTIVE' ? '#F59C1E' : '#079551',
                        color: '#fff',
                      }}
                    >
                      {item?.status}
                    </Box>
                  ),
                },
              ]}
              onRowClick={(item) =>
                navigate('/my-performance/VCPSalesDashBoard', {
                  state: { company_id: item?.company_id },
                })
              }
            />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default VcpPerformanceDirectory;
